import React from 'react';

const RequiredMark = () => {
  return <span style={{ color: 'red' }}> *</span>;
};

export default RequiredMark;
